import { Component, OnInit, Input } from '@angular/core';
import { SampleService } from '../../../core/http/sample.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sample-acknoledge-modal',
  templateUrl: './sample-acknoledge-modal.component.html',
  styleUrls: ['./sample-acknoledge-modal.component.scss'],
})
export class SampleAcknoledgeModalComponent implements OnInit {
  @Input() data;
  samples: any = [];
  isLoading = true;
  Errors = null;
  encounters: any = [];
  Success;
  billId;
  message;
  startdate = '';
  enddate = '';
  bulk: any = [];
  disable: boolean = true;
  buildLoad: boolean = false;

  stateForm = new FormGroup({
    id: new FormControl('', Validators.required),
    bill_id: new FormControl('', Validators.required),
    is_collect_action: new FormControl('', Validators.required),
    is_acknowledge_action: new FormControl('', Validators.required),
  });

  constructor(
    private sample: SampleService,
    private _snackBar: MatSnackBar,
    private location: Location
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.isLoading = true;
    this.sample.getSamples(this.data.bill_id).subscribe(
      (resSuccess: any) => {
        // this.samples = [];
        this.isLoading = false;
        this.samples = resSuccess.filter(
          (t) => t.department_name == 'LABORATORY' && t.sample_collected == 'Y'
        );
        console.log(this.samples);
      },
      (resErr) => {
        this.isLoading = false;
        // this.Errors = resErr;
      }
    );
  }
  getSamples(billId) {
    this.sample.getSamples(this.data.bill_id).subscribe(
      (resSuccess: any) => {
        this.samples = [];
        this.samples = resSuccess.filter(
          (t) => t.department_name == 'LABORATORY' && t.sample_collected == 'Y'
        );
        console.log(this.samples);
      },
      (resErr) => {
        // this.Errors = resErr;
      }
    );
  }

  collectAll() {
    this._snackBar.open('Wait while samples are Acknowledged', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
    let i;
    for (i = 0; i < this.bulk.length; i++) {
      this.onSubmitAll(
        this.bulk[i].id,
        this.bulk[i].bill_id,
        this.bulk[i].service_name,
        this.bulk[i].id
      );
      if (this.bulk.lenght - 1 == i) {
        this._snackBar.open('Sample Acknowledge Completed', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    }
  }

  collectSelected() {
    this._snackBar.open('Wait while samples are Acknowledged', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
    let i;
    for (i = 0; i < this.bulk.length; i++) {
      this.onSubmitAll(
        this.bulk[i].id,
        this.bulk[i].bill_id,
        this.bulk[i].service_name,
        this.bulk[i].id
      );
      if (this.bulk.lenght - 1 == i) {
        this._snackBar.open('Sample Acknowledge Completed', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    }
    this.bulk = [];
  }

  markAll() {
    this.bulk = this.samples;
    this.collectSelected();
  }

  check(values: any, isCkecked: any) {
    console.log(values, isCkecked.currentTarget.checked);
    if (isCkecked.currentTarget.checked) {
      this.bulk = this.bulk.filter((t) => t.id !== values.id);
      this.bulk.push(values);
      this.disable = false;
    } else {
      this.bulk = this.bulk.filter((t) => t.id !== values.id);
    }
    console.log(this.bulk);
  }
  resulStart(sample_id, format_code) {
    let formatstr = 'Y';
    console.log(sample_id, format_code, formatstr);

    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          // this._snackBar.open('Collected Succesfully', '', {
          //   duration: 2000,
          //   verticalPosition: 'top',
          // });
        } else {
        }
      },
      (resErr) => {
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  onSubmit(e) {
    this.buildLoad = true;
    // e.preventDefault();
    this.stateForm.patchValue({
      id: e.id,
      bill_id: e.bill_id,
      is_acknowledge_action: true,
    });
    console.log(this.stateForm.value);
    this.Errors = null;
    this.Success = null;
    const { id, bill_id, is_collect_action, is_acknowledge_action } =
      this.stateForm.value;
    this.sample
      .updateRecord(id, bill_id, is_collect_action, is_acknowledge_action)
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.buildLoad = false;
          console.log(resSuccess);

          if (this.message.success) {
            this.getSamples(this.billId);
            this.resulStart(e.id, e.service_name);
            this._snackBar.open('Sample Acknowledged Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            // window.location.reload();
          } else {
            this.Errors = 'Sample already acknowledged';
            console.log('error');
            this._snackBar.open('Sample already acknowledged', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.buildLoad = true;
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  onSubmitAll(Id, billId, service, sample_id) {
    // e.preventDefault();
    this.stateForm.patchValue({
      id: Id,
      bill_id: billId,
      is_acknowledge_action: true,
    });
    console.log(this.stateForm.value);
    this.Errors = null;
    this.Success = null;
    const { id, bill_id, is_collect_action, is_acknowledge_action } =
      this.stateForm.value;
    this.sample
      .updateRecord(id, bill_id, is_collect_action, is_acknowledge_action)
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          console.log(resSuccess);

          if (this.message.success) {
            this.getSamples(this.data.bill_id);
            this.resulStart(sample_id, service);
            // this._snackBar.open('Sample acknowledged Successfully', '', {
            //   duration: 2000,
            //   verticalPosition: 'top',
            // });
            // window.location.reload();
          } else {
            this.Errors = 'Sample Already acknowledged';
            console.log(resSuccess);
            // this._snackBar.open('Sample Already Collected', '', {
            //   duration: 2000,
            //   verticalPosition: 'top',
            // });
          }
        },
        (resErr) => {
          this.Errors = resErr;
          // this._snackBar.open('Error please try again', '', {
          //   duration: 2000,
          //   verticalPosition: 'top',
          // });
          console.log(resErr);
        }
      );
  }
}
